import { Component, OnInit } from '@angular/core';
import { PoModule, PoNotificationService, PoTableColumn, PoTableLiterals } from '@po-ui/ng-components';
import { ApiService } from '../../services/api.service';
import { LocalStorageType } from '../../types/localStorage.type';
import { downloadFile } from '../../utils/download.utils';
import { SessionService } from '../../services/session.service';
import { Router } from '@angular/router';
import { clearSessionData } from '../../utils/clearSessionData.util';
import { TenantService } from '../../services/tenant.service';
import { CommonModule } from '@angular/common';
import { CardComponent } from "./card/card/card.component";
import { SalesOrderReportService } from '../../services/sales-order-report.service';
import { formatCEP } from '../../utils/format.utils';
import { PaginationComponent } from '../../shared/components/pagination/pagination.component';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';

interface salesOrderItens {
  productCode: string;
  productName: string;
  referenceCode: string;
  quantity: number;
  settledQuantity: number;
  price: number;
  discountValue: number;
  totalValue: number;
}

@Component({
  standalone: true,
  imports: [PoModule, CommonModule, CardComponent, PaginationComponent],
  selector: 'sales-order',
  templateUrl: './sales-order.component.html',
  styleUrls: ['./sales-order.component.css']
})
export class SalesOrderComponent implements OnInit {

  loadingSize: string = 'md';
  loadingText: string = '';
  isLoadingHidden = true;
  isMobile: boolean = window.innerWidth <= 768;
  isHiddenPersonName: boolean = true;
  currentPage: number = 1;
  isDisableShowMore: boolean = false;
  totalPages: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;
  public totals = {
    grossValue: 0,
    discountValue: 0,
    freightValue: 0,
    totalValue: 0,
  };

  constructor(
    private apiService: ApiService,
    private poNotification: PoNotificationService,
    private sessionService: SessionService,
    private router: Router,
    private tenantService: TenantService,
    private reportService: SalesOrderReportService
  ) {
    registerLocaleData(ptBr, 'pt-BR');
  }

  async ngOnInit(): Promise<void> {
    await this.searchSalesOrder();
  }

  async searchSalesOrder() {
    if (!this.onValidToken())
      return;

    this.isLoadingHidden = false;

    await this.apiService.setterHeader('PTCAPP004');
    let branchCodeList: string[] = [];
    const storageBranches = JSON.parse(localStorage.getItem(LocalStorageType.Branches) || '[]');
    branchCodeList = storageBranches.map((item: any) => {
      const key = Object.keys(item)[0];
      return item[key].branchCode.toString();
    });

    const body = {
      page: this.currentPage,
      pageSize: this.pageSize,      
      order: "-invoiceDate, branchCode"
    };

    this.apiService.postOrdersSearch(body).subscribe(
      (response) => {
        const storageBranches = JSON.parse(
          localStorage.getItem(LocalStorageType.Branches) || '[]',
        );
        this.totalPages = response.totalPages;
        this.totalItems = response.count;

        this.totals = response.items.reduce(
          (acc: any, item: any) => {
            return {
              grossValue: 0 + acc.grossValue + (item.grossValue || 0),
              discountValue: 0 + acc.discountValue + (item.discountValue || 0),
              freightValue: 0 + acc.freightValue + (item.freightValue || 0),
              totalValue: 0 + acc.totalValue + (item.totalValue || 0),
            };
          },
          {
            grossValue: 0,
            discountValue: 0,
            freightValue: 0,
            totalValue: 0,
          },
        );

        this.items = response.items.map((item: any) => {
          const branch = storageBranches.find((branchItem: any) => branchItem[item.branchCode]);

          var personName = item.personName || '';
          if (this.isHiddenPersonName === true && personName.length > 0) {
            this.isHiddenPersonName = false;
            this.columns = this.columns.map(column => {
              if (column.property === 'personName') {
                return { ...column, visible: true };
              }
              return column;
            });
          }

          return {
            branchCode: item.branchCode,
            fantasyName: branch ? branch[item.branchCode].fantasyName : null,
            personName: item.personName,
            orderCode: item.orderCode,
            billingForecastDate: item.billingForecastDate !== '0001-01-01T00:00:00' ? item.billingForecastDate : null,
            statusOrder: this.descStatusOrder(item.statusOrder),
            stageOrder: item.stageOrder,
            quantity: item.quantity,
            grossValue: item.grossValue,
            discountValue: item.discountValue,
            freightValue: item.freightValue,
            totalValue: item.totalValue,
            detail: item.quantity > 0
              ? [{
                productCode: '',
                productName: '',
                referenceCode: '',
                quantity: '',
                settledQuantity: '',
                price: '',
                discountValue: '',
                totalValue: '',
              }]
              : [],
            iconPDF: 'pdf',
          };
        });
        this.isLoadingHidden = true;
      },
      (error) => {
        if (error.error && Array.isArray(error.error) && error.error.length > 0) {
          const errorMessage = error.error[0].message || 'Erro desconhecido.';
          this.poNotification.error(errorMessage);
        } else if (error.message) {
          this.poNotification.error(error.message);
        } else {
          this.poNotification.error('Ocorreu um erro desconhecido.');
        }
        this.isLoadingHidden = true;
      }
    );
  }

  async getSalesOrderItems(index: number, branchCode: number, orderCode: number) {
    if (!this.onValidToken())
      return;

    this.isLoadingHidden = false;

    await this.apiService.setterHeader('PTCAPP004');

    this.apiService.getSalesOrderItem(branchCode, orderCode).subscribe(
      response => {
        if (this.items && this.items[index]) {
          this.items[index].detail = response.items.map((item: any) => ({
            productCode: item.productCode,
            productName: item.productName,
            referenceCode: item.referenceCode,
            quantity: item.quantity,
            settledQuantity: item.settledQuantity,
            price: item.price,
            discountValue: item.discountValue,
            totalValue: item.totalValue
          }));
        }
        this.isLoadingHidden = true;
      },
      error => {
        if (error.error && Array.isArray(error.error) && error.error.length > 0) {
          const errorMessage = error.error[0].message || 'Erro desconhecido.';
          this.poNotification.error(errorMessage);
        } else if (error.message) {
          this.poNotification.error(error.message);
        } else {
          this.poNotification.error('Ocorreu um erro desconhecido.');
        }
        this.isLoadingHidden = true;
      }
    );
  }

  title = "Pedidos"
  customLiterals: PoTableLiterals = {
    noData: ''
  };

  items!: Array<any>;

  columns: Array<PoTableColumn> = [
    { property: 'branchCode', label: 'Código', type: 'number', visible: false },
    { property: 'fantasyName', label: 'Empresa', type: 'string', visible: false },
    { property: 'personName', label: 'Nome', type: 'string', visible: false },
    { property: 'orderCode', label: 'Pedido', type: 'number' },
    { property: 'billingForecastDate', label: 'Previsão de faturamento', type: 'date' },
    { property: 'statusOrder', label: 'Situação', type: 'string' },
    { property: 'stageOrder', label: 'Estágio', type: 'string' },
    { property: 'quantity', label: 'Quantidade', type: 'number' },
    { property: 'grossValue', label: 'Valor bruto', type: 'currency', format: 'BRL' },
    { property: 'discountValue', label: 'Desconto', type: 'currency', format: 'BRL' },
    { property: 'freightValue', label: 'Frete', type: 'currency', format: 'BRL' },
    { property: 'totalValue', label: 'Total do pedido', type: 'currency', format: 'BRL' },
    {
      property: 'iconPDF', label: 'PDF', type: 'icon', icons: [
        { value: 'pdf', icon: 'ph ph-file-pdf', color: 'color-01', tooltip: 'Baixar PDF', action: this.downloadPDF.bind(this) }
      ]
    },
    {
      property: 'detail', label: 'Detalhes', type: 'detail', detail: {
        columns: [
          { property: 'productCode', label: 'Codigo', type: 'number' },
          { property: 'productName', label: 'Descrição', type: 'string' },
          { property: 'referenceCode', label: 'Referência', type: 'string' },
          { property: 'quantity', label: 'Quantidade', type: 'number' },
          { property: 'settledQuantity', label: 'Qtde. atendida', type: 'number' },
          { property: 'price', label: 'Vl. unitário', type: 'currency', format: 'BRL' },
          { property: 'discountValue', label: 'Vl. desconto', type: 'currency', format: 'BRL' },
          { property: 'totalValue', label: 'Vl. total', type: 'currency', format: 'BRL' }
        ],
        typeHeader: 'top'
      }
    }
  ];

  onExpandDetail(event: any) {
    const index = this.items.findIndex(
      (item: any) => item.branchCode === event.branchCode && item.orderCode === event.orderCode
    );

    if (event.detail[0].productCode > 0) {
      return;
    }

    const { branchCode, orderCode } = event;
    if (branchCode && orderCode) {
      this.getSalesOrderItems(index, branchCode, orderCode);
    }
  }

  private descStatusOrder(statusOrder: string): string {
    switch (statusOrder) {
      case 'InProgress':
        return 'Em andamento';
      case 'BillingReleased':
        return 'Liberado para faturamento';
      case 'PartiallyAnswered':
        return 'Parcialmente atendido';
      case 'Attended':
        return 'Atendido';
      case 'Blocked':
        return 'Bloqueado';
      case 'Canceled':
        return 'Cancelado';
      case 'InComposition':
        return 'Em composição';
      case 'InAnalysis':
        return 'Em análise';
      default:
        return 'Situação desconhecida';
    }
  }

  private onValidToken() {
    if (this.sessionService.isTokenExpiredOrNull().hasAccess !== true) {
      clearSessionData();
      this.router.navigate(['/login'], { queryParams: { tenant: this.tenantService.getTenant() } });
      return false
    }

    return true
  }

  private async loadSalesOrderItems(branchCode: number, orderCode: number): Promise<salesOrderItens[]> {
    this.isLoadingHidden = false;
    await this.apiService.setterHeader('PTCAPP004');

    return new Promise((resolve, reject) => {
      this.apiService.getSalesOrderItem(branchCode, orderCode).subscribe(
        response => {
          const itens = response.items.map((item: any) => ({
            productCode: item.productCode,
            productName: item.productName,
            referenceCode: item.referenceCode,
            quantity: item.quantity,
            settledQuantity: item.settledQuantity,
            price: item.price,
            discountValue: item.discountValue,
            totalValue: item.totalValue
          }));
          this.isLoadingHidden = true;
          resolve(itens);
        },
        error => {
          if (error.error && Array.isArray(error.error) && error.error.length > 0) {
            const errorMessage = error.error[0].message || 'Erro desconhecido.';
            this.poNotification.error(errorMessage);
          } else if (error.message) {
            this.poNotification.error(error.message);
          } else {
            this.poNotification.error('Ocorreu um erro desconhecido.');
          }
          this.isLoadingHidden = true;
          reject([]);
        }
      );
    });
  }

  async onCarregarItensCard(event: { item: any }) {
    const { item } = event;

    const itens = await this.loadSalesOrderItems(item.branchCode, item.orderCode);
    item.salesOrderItens = itens;
  }

  private downloadPDF(row: any) {
    if (!this.onValidToken())
      return;

    this.isLoadingHidden = false;
    this.apiService.postAction("GERAR_PDFPEDIDO").subscribe();

    this.apiService.getSalesOrderReport(row.branchCode, row.orderCode).subscribe(
      async (response) => {
        const order = response;

        const mockData = {
          company: {
            cnpj: order.companyCnpj || '',
            name: order.companyName || '',
            address: `${order.companyAddress || ''}, ${order.companyAddressNumber || ''} - ${order.companyNeighborhood || ''}, ${order.companyCityName || ''} - ${order.companyStateAbbreviation || ''}, ${order.companyCountryAbbreviation || ''}, CEP: ${formatCEP(order.companyCep) || ''}`
          },
          customer: {
            cpfCnpj: order.customerCpfCnpj || '',
            name: order.customerName || '',
            address: `${order.shippingAddress || ''}, ${order.shippingAddressNumber || ''} - ${order.shippingNeighborhood || ''}, ${order.shippingCityName || ''} - ${order.shippingStateAbbreviation || ''}, ${order.shippingCountryAbbreviation || ''}, CEP: ${formatCEP(order.shippingCep) || ''}`
          },
          order: {
            number: order.orderCode || '',
            customerNumber: order.customerOrderCode || '',
            billingForecast: order.billingForecastDate ? new Date(order.billingForecastDate).toLocaleDateString('pt-BR') : '',
            freightValue: order.freightValue || 0,
            totalValue: order.totalValue || 0
          },
          items: Array.isArray(order.orderItems) && order.orderItems.length > 0
            ? order.orderItems.map((item: any) => ({
              code: item.productCode || '',
              description: item.productDescription || '',
              requestedQuantity: item.requestedQuantity || 0,
              unitValue: item.productUnitValue || 0,
              settedQuantity: item.settledQuantity || 0,
              discountValue: item.productDiscountValue || 0,
              totalValue: item.totalProductValue || 0
            }))
            : [{
              code: '0',
              description: '-',
              quantityRequested: 0,
              unitValue: 0,
              settedQuantity: 0,
              discountValue: 0,
              totalValue: 0
            }]
        };

        this.reportService.generatePDF(mockData);
      }
    )
    this.isLoadingHidden = true;
  }

  async downloadPDFCard(event: { item: any }) {
    const { item } = event;
    this.downloadPDF(item);
  }

  showMore() {
    this.currentPage++;
    this.searchSalesOrder();
  }

  onPageChange(newPage: number, pageSize: number) {
    this.currentPage = newPage;
    this.pageSize = pageSize;
    
    this.searchSalesOrder();
  }
}